import { useLocation } from "react-router-dom";
import DefaultPage from "../../components/containers/DefaultPage";
import NavBar, { MIN_WIDTH_FOR_MENU } from "../../components/NavBar";
import { isDesktop } from "../../utilities/getDeviceType";
import { useWindowDimensions } from "../../utils";

/* 
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
 */
const PersonalDefaultPage = ({ children }) => {
  const { height, width } = useWindowDimensions();
  const location = useLocation();
  const isGameRoute = location.pathname.startsWith("/game/");

  return (
    <DefaultPage>
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          minHeight: height,
          display: "flex",
          alignItems: "stretch",
          flexDirection: "row",
          justifyContent: "flex-start",
          overflowX: "hidden",
        }}
      >
        <NavBar />
        <div
          style={{
            // Оригинальные стили для всех страниц
            padding: width >= 1280 && width < 1400 && isDesktop() ? 10 : 25,
            paddingTop:
              width >= MIN_WIDTH_FOR_MENU && width < 1420 && isDesktop()
                ? 25
                : 68,
            display: "flex",
            flexDirection: width > 1180 ? "row" : "column",
            flexGrow: 1,
            flexShrink: 1,
            minWidth: 0,
            justifyContent: width > 1180 ? "space-around" : "flex-start",
            gap: 20,
            // Специальные стили ТОЛЬКО для игр (переопределяют выше)
            ...(isGameRoute && {
              padding: 0,
              paddingTop: 0,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 0,
              height: "100vh",
              width: "100%",
              overflow: "hidden",
            }),
          }}
        >
          {children}
        </div>
      </div>
    </DefaultPage>
  );
};

export default PersonalDefaultPage;
